"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_STORAGE_KEY_LOCALE = exports.DEFAULT_LOCALE = exports.dateTimeFormat = exports.formats = void 0;
// Reference for the default formats:
// https://github.com/formatjs/formatjs/blob/5e9a425519fd2b2473172687fccb58a6979ec81e/packages/intl-messageformat/src/core.ts#L208
exports.formats = {
    number: {
        integer: {
            maximumFractionDigits: 0,
        },
        currency: {
            style: 'currency',
        },
        percent: {
            style: 'percent',
        },
    },
    date: {
        medium: {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        },
    },
    time: {
        short: {
            hour: '2-digit',
            minute: '2-digit',
        },
        medium: {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        },
    },
};
exports.dateTimeFormat = {
    ...exports.formats.date.medium,
    ...exports.formats.time.short,
};
exports.DEFAULT_LOCALE = 'en';
exports.LOCAL_STORAGE_KEY_LOCALE = '@templafy/translation/locale';
//# sourceMappingURL=constants.js.map